<template>
    <DForm @submit.prevent="submitForm">
        <DFormRow
            :label="__('settings.whmcs_settings.form.api_url')"
            :is-required="true"
            :hint="__('settings.whmcs_settings.form.api_url_hint')"
        >
            <DInput
                id="api_url"
                v-model="form.api_url"
                :placeholder="__('settings.whmcs_settings.form.api_url')"
                add-input-classes="bg-light"
                :is-valid="isFormFieldValid('api_url')"
                :invalid-feedback="errorsData.api_url"
                maxlength="255"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.whmcs_settings.form.username')"
            :is-required="true"
            :hint="__('settings.whmcs_settings.form.username_hint')"
        >
            <DInput
                id="username"
                v-model="form.username"
                :placeholder="__('settings.whmcs_settings.form.username')"
                add-input-classes="bg-light"
                :is-valid="isFormFieldValid('username')"
                :invalid-feedback="errorsData.username"
                maxlength="255"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.whmcs_settings.form.password')"
            :is-required="whmcsSettings === null"
            :hint="__('settings.whmcs_settings.form.password_hint')"
        >
            <DInput
                id="password"
                v-model="form.password"
                :placeholder="__('settings.whmcs_settings.form.password')"
                add-input-classes="bg-light"
                :is-valid="isFormFieldValid('password')"
                :invalid-feedback="errorsData.password"
                maxlength="255"
            />
        </DFormRow>
        <DRow>
            <DCol sm="4" />
            <DCol sm="4">
                <div
                    v-if="connectionStatus === 'successful'"
                    class="green-text"
                >
                    {{ __('settings.whmcs_settings.connection_successful') }}
                </div>
                <div
                    v-if="connectionStatus === 'unsuccessful'"
                    class="red-text"
                >
                    {{ __('settings.whmcs_settings.connection_unsuccessful') }}
                </div>
            </DCol>
            <DCol
                sm="4"
                class="check-database-connection-btn"
            >
                <DButton
                    icon="lan-connect"
                    :label="__('settings.whmcs_settings.check_connection')"
                    :disabled="isInLoadingState"
                    @click="checkConnection"
                />
            </DCol>
        </DRow>
        <DFormControls
            v-show="credentialsValid"
            :dirty="form.isDirty"
            @submit="submitForm"
        />
        <DConnectionErrorModal
            :show-modal="connectionException !== null"
            :exception="connectionException"
            @close-modal="closeErrorCheckModal"
        />
    </DForm>
</template>

<script>

import DConnectionErrorModal from '~@/Components/Common/DConnectionErrorModal'

export default {
    name: 'WhmcsSettingsForm',
    components: { DConnectionErrorModal },
    props: {
        whmcsSettings: {
            type: Object,
            default: () => { return {} }
        },
        errors: {
            type: Object,
            default: () => { return {} }
        }
    },
    emits: ['form-submitted'],
    data () {
        return {
            form: this.$inertia.form({
                api_url: this.whmcsSettings?.api_url ?? null,
                username: this.whmcsSettings?.username ?? null,
                password: this.whmcsSettings?.password ?? null
            }),
            connectionStatus: '',
            credentialsValid: false,
            connectionException: null,
            error: null,
            errorsData: this.errors
        }
    },

    methods: {
        submitForm () {
            this.$emit('form-submitted', this.form)
        },
        checkConnection () {
            this.errorsData = {}
            const self = this
            self.connectionException = null
            window.axios.post(this.$route('settings.whmcs-settings.check', this.form))
                .then(function () {
                    self.connectionStatus = 'successful'
                    self.credentialsValid = true
                })
                .catch(function (error) {
                    self.connectionStatus = 'unsuccessful'
                    self.credentialsValid = false
                    if (error.response.data.error !== undefined) {
                        self.error = error.response.data.error
                    }
                    if (error.response.data.errors !== undefined) {
                        self.errorsData = error.response.data.errors

                        for (const key in self.errorsData) {
                            if (typeof self.errorsData[key] === 'object') {
                                self.errorsData[key] = self.errorsData[key][0]
                            }
                        }
                    }
                    if (error?.response.data.exception !== undefined) {
                        self.connectionException = error.response.data.exception
                    }
                })
        },
        closeErrorCheckModal () {
            this.connectionException = null
            this.error = null
        }
    }
}
</script>

<style scoped>
.check-database-connection-btn {
    text-align: right;
    padding-bottom: 25px;
}
.green-text {
    color: green;
}
.red-text {
    color: red;
}
</style>
